/* global mainScript */
import React, { useState } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//style rules
import { Colors, Typography } from "../../styles";

const DropDown = ({
	DropDownLabel,
	filters,
	handleFilterSelect,
	selectedFilters,
}) => {
	const [openFiltersDropDown, setOpenFiltersDropDown] = useState(false);

	const toggleDropDown = () => {
		setOpenFiltersDropDown((currentValue) => !currentValue)
	}

	const renderFilters = () => {
		return (
			filters &&
			filters.length > 0 &&
			filters.map((filter) => {
				return (
					<DropDownListItem
						key={filter.slug}
						onClick={() => handleFilterSelect(filter)}
					>
						<CheckboxLabel>{filter.name}</CheckboxLabel>
						<input
							type={"checkbox"}
							onChange={() => {}}
							checked={
								selectedFilters &&
								selectedFilters.length > 0 &&
								selectedFilters.some((sf) => sf.slug === filter.slug)
							}
						/>
					</DropDownListItem>
				);
			})
		);
	};

	return (
		<DropDownContainer>
			<DropDownTrigger
				onClick={toggleDropDown}
				onKeyPress={toggleDropDown}
			>
				{DropDownLabel}
			</DropDownTrigger>
			{openFiltersDropDown && <DropDownList>{renderFilters()}</DropDownList>}
		</DropDownContainer>
	);
};

export default DropDown;

DropDown.propTypes = {
	DropDownLabel: PropTypes.string,
	filters: PropTypes.array,
	handleFilterSelect: PropTypes.func,
	selectedFilters: PropTypes.array,
};

const DropDownContainer = styled.div`
	position: relative;
	width: fit-content;
`;

const DropDownTrigger = styled.button`
	padding: 1.3rem 1.5rem;
	width: fit-content;
	text-transform: capitalize;
	border: 1px solid ${Colors.base.black};
	font-weight: 700;
	font-size: 1.3rem;
	line-height: 1.6rem;
	border-radius: 2px;
	cursor: pointer;
	display: flex;
	gap: 6.1rem;
	height: unset;
    background: none;
	transition: all 0.5s;

	&::after {
		content: url(${mainScript.assetPath +
		"images/svg/icons/icon-down-arrow.svg"});
	}
`;
const DropDownList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	margin: 0;
	padding: 1.6rem 1.5rem 2rem;
	width: 100%;
	position: absolute;
	top: 40px;
	z-index: 2;
	background-color: ${Colors.base.white};
	border-bottom: 1px solid ${Colors.base.black};
	border-left: 1px solid ${Colors.base.black};
	border-right: 1px solid ${Colors.base.black};
`;

const DropDownListItem = styled.li`
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	input[type="checkbox"] {
		min-width: 15px;
		height: 15px;
		margin: 0;
		border-radius: 3px;

		&:before {
			content: "✓";
			display: block;
			transform: translateX(-100%);
		}

		&:checked::before {
			transform: translateY(-14%);
		}
	}
`;

const CheckboxLabel = styled.label`
	font-size: 1rem;
	line-height: 1.6rem;
	font-weight: ${Typography.fontWeight.regular};
`;
